/**
 * Nymia · Landing / Creator Page — Image URLs
 * ───────────────────────────────────────────────────────────────────────
 *  Per cambiare una fotografia basta modificare l'URL qui sotto.
 *  NESSUNA modifica al codice React è necessaria.
 *
 *  NeoLanding (restyling cinematografico): fotografie generate ad hoc —
 *  persone vere, luce calda, atmosfera cinematografica, palette
 *  nero/oro/bianco. Nessun effetto "AI", nessuna foto stock patinata.
 * ───────────────────────────────────────────────────────────────────────
 */

// ═══════════════════════════════════════════════════════════════════════
//  LANDING HOME  (nymia.me/)
//  Vibe: le persone prima di tutto — calore, autenticità, cinema.
// ═══════════════════════════════════════════════════════════════════════
export const LANDING_IMAGES = {
  // Hero — microfono da studio, luce dorata, atmosfera cinematografica
  hero:
    'https://static.prod-images.emergentagent.com/jobs/70cab226-6488-47ae-8a5f-b42665648727/images/0e5ec46510e4c061fd63a9bddd7cf749d9556e233628758d164745590d0610b7.png',

  // «Nymia, nella tua vita di tutti i giorni» — 3 colonne.
  // Per sostituire una foto basta cambiare l'URL della chiave corrispondente.
  dailyCooking:
    'https://static.prod-images.emergentagent.com/jobs/70cab226-6488-47ae-8a5f-b42665648727/images/0c19a30ad35c277abe42c649d35e89465ae7b7ebf88a2a165a8972910da59f6f.jpeg',
  dailyCar:
    'https://static.prod-images.emergentagent.com/jobs/70cab226-6488-47ae-8a5f-b42665648727/images/8d1f3ac4827930d60f4c9875b2068d55a4c5fa2a3f902e84476f8adafcad8def.jpeg',
  dailyHome:
    'https://static.prod-images.emergentagent.com/jobs/70cab226-6488-47ae-8a5f-b42665648727/images/fdb6e4c6dfba5055540f59360406343cc3f64764b4eb9dc696ccfd2f3c04aa88.jpeg',
};

// ═══════════════════════════════════════════════════════════════════════
//  CREATOR PAGE  (nymia.me/creator)
//  Vibe: creator al lavoro, artisti veri, dietro le quinte.
//  NIENTE dashboard, NIENTE grafici, NIENTE modelli patinati.
// ═══════════════════════════════════════════════════════════════════════
export const CREATOR_IMAGES = {
  // Hero — creator autentico (podcaster / musicista / artista al lavoro)
  hero:
    'https://images.unsplash.com/photo-1590602847861-f357a9332bbc?auto=format&fit=crop&w=1600&q=85',

  // Sezione "Il paradosso dei social" — persona che riflette
  paradox:
    'https://images.unsplash.com/photo-1455390582262-044cdead277a?auto=format&fit=crop&w=1200&q=80',

  // Sezione "Nymia nasce da una domanda" — momento di creazione
  question:
    'https://images.unsplash.com/photo-1513364776144-60967b0f800f?auto=format&fit=crop&w=1200&q=80',

  // Sezione "Non ti chiediamo di pubblicare di più" — mani che creano
  craft:
    'https://images.unsplash.com/photo-1511671782779-c97d3d27a1d4?auto=format&fit=crop&w=1200&q=80',

  // Sezione "Il tuo lavoro merita di più di un mi piace"
  worthMore:
    'https://images.unsplash.com/photo-1478737270239-2f02b77fc618?auto=format&fit=crop&w=1200&q=80',

  // Manifesto — grande visual conclusivo (community reale con creator)
  manifesto:
    'https://images.unsplash.com/photo-1529333166437-7750a6dd5a70?auto=format&fit=crop&w=1600&q=85',
};

// ═══════════════════════════════════════════════════════════════════════
//  DISCOVER PAGE  (nymia.me/cosa-puoi-fare)
//  Vibe: persone vere di età e background diversi, luce calda, nero/oro.
// ═══════════════════════════════════════════════════════════════════════
export const DISCOVER_IMAGES = {
  writing:
    'https://static.prod-images.emergentagent.com/jobs/70cab226-6488-47ae-8a5f-b42665648727/images/901e1e4c38b41505830ebe1576b1720edbaf17e3ddd98a82de930b97060aa778.png',
  voice:
    'https://static.prod-images.emergentagent.com/jobs/70cab226-6488-47ae-8a5f-b42665648727/images/f39a5178cfe229145b4a805153eb2e1e8b5f2a621bbf5f5c0122859ec82cfad5.png',
  liveAudio:
    'https://static.prod-images.emergentagent.com/jobs/70cab226-6488-47ae-8a5f-b42665648727/images/f08987e5d8bce3a03aed6ccf015aa7dd820ccccb9aae20c3a7b3556d4f389603.png',
  oneToOne:
    'https://static.prod-images.emergentagent.com/jobs/70cab226-6488-47ae-8a5f-b42665648727/images/3e038cc5a08f31db543b88eb6bd862ee6c67f04f59ca325b4b7c25038b681f00.png',
  minute:
    'https://static.prod-images.emergentagent.com/jobs/70cab226-6488-47ae-8a5f-b42665648727/images/53f3bec5663fb103c8bed1d3d69adf96c560f1f96243dc863a48163a574b2189.png',
  community:
    'https://static.prod-images.emergentagent.com/jobs/70cab226-6488-47ae-8a5f-b42665648727/images/98d828117c6687566f34b44ef26b359ef01b0a3106a93f4af6f6359aaa481a07.png',
};

export default {
  LANDING_IMAGES,
  CREATOR_IMAGES,
  DISCOVER_IMAGES,
};
